import { Popover, Transition } from '@headlessui/react';
import { FC, Fragment, useEffect, useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { twMerge } from 'tailwind-merge';
import { VoidFn } from 'types/baseTypes';
import SearchBar from './SearchBar';
import SearchSuggestionsPanel from './SearchSuggestionsPanel';

interface SearchPopoverProps {
  suggestionsList: string[];
  searchInputvalue: string;
  onSearchInputChange: (text: string) => void;
  searchInputPlaceholder?: string;
  onClearSearchInput: VoidFn;
  wrapperStyle?: string;
  autoFocus?: boolean;
  searchId: string;
}

// TODO change to combobox
const SearchPopover: FC<SearchPopoverProps> = ({
  searchId,
  searchInputvalue,
  suggestionsList,
  onSearchInputChange,
  searchInputPlaceholder,
  onClearSearchInput,
  wrapperStyle,
  autoFocus = true
}) => {
  const [isSuggestionsListVisible, setIsSuggestionsListVisible] = useState(false);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);

  const getFilteredSuggestionList = () => {
    const suggestions = suggestionsList?.filter((suggestion: string) => {
      return suggestion.toLowerCase().includes(searchInputvalue.toLowerCase());
    });
    return suggestions;
  };

  useEffect(() => {
    const filteredList = getFilteredSuggestionList();
    if (filteredList?.length === 0) {
      setIsSuggestionsListVisible(false);
    }
    setFilteredSuggestions(filteredList);
  }, [searchInputvalue, suggestionsList]);

  const handleSearchInputChange = (text: string) => {
    if (!isSuggestionsListVisible) {
      setIsSuggestionsListVisible(true);
    }
    onSearchInputChange(text);
  };

  const onSelectSuggestedItem = text => {
    handleSearchInputChange(text);
    setIsSuggestionsListVisible(false);
  };

  const onOutSideClick = () => {
    setIsSuggestionsListVisible(false);
  };

  const onClearSearch = () => {
    setIsSuggestionsListVisible(false);
    onClearSearchInput();
  };

  return (
    <OutsideClickHandler onOutsideClick={onOutSideClick}>
      <div className={twMerge('w-full', wrapperStyle)}>
        <Popover className="relative">
          {() => (
            <>
              <SearchBar
                id={searchId}
                autoFocus={autoFocus}
                value={searchInputvalue}
                handleClear={onClearSearch}
                placeholder={searchInputPlaceholder}
                showSearchIcon={true}
                handleChange={handleSearchInputChange}
                wrapperStyle="w-full border border-[#ACB5BD] rounded"
                showCrossIcon={true}
              />
              <Transition
                show={isSuggestionsListVisible}
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 translate-y-1"
                enterTo="opacity-100 translate-y-0"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-1">
                <Popover.Panel
                  className="customNormalScroll absolute z-40 mt-[2px] max-h-36 w-full
                 overflow-y-auto rounded-md border border-borderGray bg-primary shadow-md">
                  <SearchSuggestionsPanel
                    onSelectListItem={onSelectSuggestedItem}
                    suggestionsList={filteredSuggestions}
                  />
                </Popover.Panel>
              </Transition>
            </>
          )}
        </Popover>
      </div>
    </OutsideClickHandler>
  );
};

export default SearchPopover;
